import VolumeOffIcon from '@material-ui/icons/VolumeOff';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';
import React from 'react';


function MuteButton(props) {
  const {
    isMuted,
    isFeaturedClip,
    onMute,
  } = props;

  if (!isFeaturedClip) {
    return null;
  }

  const VolumeIcon = isMuted ? VolumeOffIcon : VolumeUpIcon;

  return (
    <button className="mute-overlay-dark" onClick={onMute}>
      <VolumeIcon className="mute-btn" />
    </button>
  );
}

export default MuteButton;
